import styled from 'styled-components'
import { typoHeading2, typoHeading3 } from '../../../lib/styles/Typography'

export const Styled = {
  Container: styled.div<{ isOpen?: boolean }>`
    position: relative;
    z-index: ${({ isOpen }) => (isOpen ? 10 : 0)};
  `,
  GroupLetter: styled.div`
    ${typoHeading2}

    @media screen and (max-width: 768px) {
      ${typoHeading3}
    }
  `,
  Dropdown: styled.div<{
    isOpen?: boolean
  }>`
    background: ${p => p.theme.colors.white[1]};
    border-radius: 0.4rem;
    box-shadow: ${p => p.theme.shadows.menuOpen};
    left: 0;
    opacity: ${p => (p.isOpen ? 1 : 0)};
    padding: 0.5rem;
    position: absolute;
    top: 100%;
    transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
    visibility: ${p => (p.isOpen ? 'visible' : 'hidden')};
    z-index: 100;
  `,
  DropdownInner: styled.div`
    display: flex;
    flex-direction: column;
    max-height: 13rem;
    overflow: auto;
    overscroll-behavior: contain;
    padding: 0.25rem;

    // scrollbar style
    &::-webkit-scrollbar {
      width: 0.3rem;
      background: ${p => p.theme.colors.black[6]};
      border-radius: 0.25rem;
    }

    &::-webkit-scrollbar-thumb {
      background: ${p => p.theme.colors.black[4]};
      width: 0.15rem;
      border-radius: 0.25rem;

      &:hover {
        background: ${p => p.theme.colors.black[3]};
      }

      &:active {
        background: ${p => p.theme.colors.black[2]};
      }
    }
  `,
}
